import { styled } from 'goober';

const Button = styled('button')`
  width: 100%;
  padding: 8px 12px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  color: var(--on-accent);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(22, 160, 133, 0.2);
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(22, 160, 133, 0.3);
  }
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  &:disabled {
    background: var(--disabled-bg);
    color: var(--disabled-text);
    cursor: not-allowed;
    box-shadow: none;
  }
`;

interface CalculateButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export function CalculateButton({ disabled, onClick }: CalculateButtonProps) {
  return (
    <Button id="iso-calculate" data-testid="iso-calculate" disabled={disabled} onClick={onClick}>
      Calculer
    </Button>
  );
}
